var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAvatar9 = function SvgAvatar9(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#avatar-9_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1788FB",
    d: "M60 30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30 16.569 0 30-13.431 30-30Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4A72C",
    d: "m20.907 40.417-1.165-1.165-1.165-1.165s-2.302-.3-4.102 2.235c-1.8 2.535-1.47 5.668-1.47 5.668s3.132.33 5.667-1.47c2.535-1.803 2.235-4.103 2.235-4.103Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D13346",
    d: "m24.01 39.945-4.958-4.958-1.98 1.596 5.343 5.342 1.595-1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M46.995 12.002s-9.792-.585-18.707 7.35C19.373 27.288 17.12 35.126 17.12 35.126s2.048 1.51 3.645 3.108L46.998 12l-.003.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26517F",
    d: "M8.045 33.895s3.747-8.245 13.465-7.04c9.717 1.203-4.073 7.355-4.073 7.355s-3.055-2.248-9.392-.313v-.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "M46.995 12.002s.585 9.793-7.35 18.708-15.772 11.167-15.772 11.167-1.51-2.047-3.108-3.645L46.998 12l-.003.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E3A54",
    d: "M25.103 50.953s8.245-3.748 7.04-13.466c-1.203-9.717-7.355 4.073-7.355 4.073s2.247 3.055.312 9.392h.003Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26517F",
    d: "M29.237 29.76s-4.02 1.685-7.54 5.205c-3.52 3.52-5.205 7.54-5.205 7.54L29.237 29.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E3A54",
    d: "M29.237 29.76s-1.685 4.02-5.205 7.54c-3.52 3.52-7.54 5.205-7.54 5.205L29.237 29.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4A72C",
    d: "M34.617 27.633a3.252 3.252 0 1 0 0-6.505 3.252 3.252 0 0 0 0 6.505Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D13346",
    d: "m39.827 19.17 7.168-7.168s-5.383-.317-11.8 2.75a133.355 133.355 0 0 1 4.632 4.418Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A51C34",
    d: "m39.828 19.17 7.167-7.168s.318 5.383-2.75 11.8a133.355 133.355 0 0 0-4.417-4.632Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "avatar-9_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v60H0z"
  })))));
};
export { SvgAvatar9 as ReactComponent };
export default __webpack_public_path__ + "static/media/avatar-9.86249968bc7c5ccdcb4f.svg";